import Dialog, { type DialogProps } from '@mui/material/Dialog';
import Portal, { type PortalProps } from '@mui/material/Portal';

type FormModalProps = DialogProps & Pick<PortalProps, 'container'>;

function FormModal({ container, ...props }: FormModalProps) {
  return (
    <Portal container={container}>
      <Dialog disablePortal {...props} />
    </Portal>
  );
}

export type { FormModalProps };
export { FormModal };
